import { useState } from "react";
import { Eyebrow } from "@/components/media/Sections";
import { X } from "lucide-react";

/** Event photo gallery with a lightbox. */
export const EventGallery = ({ gallery }) => {
  const photos = gallery?.photos || [];
  const [open, setOpen] = useState(null);
  if (!photos.length) return null;

  return (
    <>
      <Eyebrow>THE GALLERY</Eyebrow>
      <h2 className="neon mt-3 max-w-3xl text-4xl leading-tight sm:text-5xl">{gallery.title}</h2>
      <p className="mt-4 max-w-2xl text-base text-muted-foreground md:text-lg">{gallery.intro}</p>

      <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4">
        {photos.map((p, i) => (
          <button
            key={p.id}
            data-testid={`gallery-photo-${p.id}`}
            onClick={() => setOpen(p)}
            className={`group relative overflow-hidden border border-border bg-black ${
              i % 5 === 0 ? "md:col-span-2 md:row-span-2" : ""
            }`}
            style={{ aspectRatio: i % 5 === 0 ? "1/1" : "4/5" }}
          >
            <img
              src={p.image}
              alt={p.caption || ""}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A0A0A] to-transparent p-3 text-left">
              <span className="mono block text-[9px] tracking-widest text-primary">{p.tag}</span>
              <span className="mono mt-1 block text-[10px] leading-snug tracking-widest text-white">
                {p.caption}
              </span>
            </span>
          </button>
        ))}
      </div>

      {open ? (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setOpen(null)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/92 p-5"
        >
          <button
            data-testid="gallery-lightbox-close"
            className="absolute right-5 top-5 text-white hover:text-primary"
            aria-label="Close"
          >
            <X size={26} />
          </button>
          <figure className="max-h-full">
            <img src={open.image} alt={open.caption || ""} className="max-h-[80vh] w-auto" />
            <figcaption className="mono mt-4 text-center text-[11px] tracking-widest text-muted-foreground">
              {open.caption}
            </figcaption>
          </figure>
        </div>
      ) : null}
    </>
  );
};
